import { Archivable } from '@pixacare/shared';

export const toArchivable = ({ archivedBy, archivedOn, isArchived }: Archivable): Archivable => ({
  archivedBy,
  archivedOn,
  isArchived,
});
